import { createTheme } from '@mui/material/styles';
const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb', // Blue-600 from your existing color scheme
      light: '#3b82f6', // Blue-500
      dark: '#1d4ed8', // Blue-700
    },
    secondary: {
      main: '#64748b', // Gray-500
      light: '#94a3b8', // Gray-400
      dark: '#475569', // Gray-600
    },
    background: {
      default: '#ffffff',
      paper: '#f8fafc',
    },
    mode: 'light',
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
  },
});
export default theme;